import React, { Component } from 'react';
import styled from 'styled-components';

import { Font, FontWeight } from '../../utils/fonts';
import mediaWidth from '../../utils/mediaWidth/mediaWidth';

class BaseButton extends Component {
    render() {
        const { className, children, onClick } = this.props;

        return (
            <Root className={className} onClick={onClick}>
                {children}
            </Root>
        );
    }
}

const Root = styled.div`
    ${Font.HEADLINE};
    ${FontWeight.REGULAR};
    font-size: 16px;
    line-height: 19px;
    text-transform: uppercase;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0,0,0,0);

    ${mediaWidth.xl} {
        font-size: 20px;
        line-height: 23px;
    }
`;

export default BaseButton;
